<template>
  <DragPanel
    v-if="visible"
    title="漫游"
    :closePanel="closeDialog"
    :tooltipVisible="false">
    <Roaming :dataSetList="dataSetList" ref="roamAnimate" />
  </DragPanel>
</template>

<script>
import DragPanel from '@/components/CustomDragPanel.vue'
import Roaming from './RoamingForm.vue'

export default {
  data() {
    return {
      isQueryFormVisible: true
    }
  },
  props: {
    visible: Boolean,
    dataSetList: Array,
    closeDialog: Function
  },
  components: { DragPanel, Roaming },
  methods: {},
  watch: {
    visible(nv) {
      if (!nv) {
        this.$refs.roamAnimate.stopRoam(this.$refs.roamAnimate.playRoamItem)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.common-drag-panel {
  top: 214px;
  right: 20px;
  width: 360px;
  height: calc(100% - 225px);
  :deep(.content) {
    height: calc(100% - 40px);
  }
}
</style>
